import { useMemo } from 'react';

export const getViewerTimezoneName = (): string | undefined => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
};

export const useViewerTimezone = (): string | undefined => {
  return useMemo(() => getViewerTimezoneName(), []);
};
